import { StockActions } from './stock.action';
import { InitializerAction } from '@toro/common/shared/state-management/initializer/initiliazer.action';

export class StockState {
    finance: any;
    pending: boolean;
    errors: any;
    incomeDates: any;
    pendingIncomeNotes: number;
    consolidatePosition: any;
    /**
     * Notas de corretagem de opções
     */
    brokeageNoteOption: any;
    /**
     * Notas de corretagem de futuros
     */
    brokeageNoteFuture: any;
    /**
     * Notas de corretagem de ações
     */
    brokeageNoteStock: any;
}

export const initialState: StockState = {
    finance: '',
    pending: false,
    errors: null,
    consolidatePosition: null,
    incomeDates: null,
    pendingIncomeNotes: 0,
    brokeageNoteOption: null,
    brokeageNoteFuture: null,
    brokeageNoteStock: null
}

export function StockReducer(state: StockState = initialState, action: any){

    switch (action.type) {

        case StockActions.getNoteListDate:
            return {...state, ...{ pending: true, error: null } };
        case StockActions.getNoteListDateSuccess:
            return {...state, ...{ pending: false, error: null, incomeDates: action.payload } };
        case StockActions.getNoteListDateError:
            return {...state, ...{ pending: false, error: action.payload } };

        case StockActions.getBrokageNoteOption:
            return {...state, ...{ pendingIncomeNotes: state.pendingIncomeNotes + 1, error: null } };
        case StockActions.getBrokageNoteOptionSuccess:
            return {...state, ...{ pendingIncomeNotes: state.pendingIncomeNotes - 1, error: null, brokeageNote: action.payload } };
        case StockActions.getBrokageNoteOptionError:
            return {...state, ...{ pendingIncomeNotes: state.pendingIncomeNotes - 1, error: action.payload } };
        
        case StockActions.getBrokageNoteFuture:
            return {...state, ...{ pendingIncomeNotes: state.pendingIncomeNotes + 1, error: null } };
        case StockActions.getBrokageNoteFutureSuccess:
            return {...state, ...{ pendingIncomeNotes: state.pendingIncomeNotes - 1, error: null, brokeageNote: action.payload } };
        case StockActions.getBrokageNoteFutureError:
            return {...state, ...{ pendingIncomeNotes: state.pendingIncomeNotes - 1, error: action.payload } };

        case StockActions.getBrokageNoteStock:
            return {...state, ...{ pendingIncomeNotes: state.pendingIncomeNotes + 1, error: null } };
        case StockActions.getBrokageNoteStockSuccess:
            return {...state, ...{ pendingIncomeNotes: state.pendingIncomeNotes - 1, error: null, brokeageNote: action.payload } };
        case StockActions.getBrokageNoteStockError:
            return {...state, ...{ pendingIncomeNotes: state.pendingIncomeNotes - 1, error: action.payload } };

        case InitializerAction.resetUserRelatedData:
            return {...state, ...{
                                    finance: initialState.finance, 
                                    consolidatePosition: initialState.consolidatePosition, 
                                    incomeDates: initialState.incomeDates, 
                                    brokeageNoteOption: initialState.brokeageNoteOption,
                                    brokeageNoteFuture: initialState.brokeageNoteFuture,
                                    brokeageNoteStock: initialState.brokeageNoteStock
                            }
            };
        default:
            return state;
    }
};
